import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.getMyOrgSecurity, {
        orgId,
    }, options);
    if (error) return { error, status };
    return content || {
        o: 'allow',
        t: 'allow',
        p: 'allow',
        u: 'deny',
    };
};
